<template>
  <div class="resultsScreen">

    <!-- BACKGROUND CONFETTI-LIKE DOTS -->
    <div v-for="n in 16" :key="n" class="confetti-dot"></div>

    <!-- HOME BUTTON -->
    <div class="homeBtn" @click="goToHomePage">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-house-fill" viewBox="0 0 16 16">
        <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"/>
        <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"/>
      </svg>
    </div>

    <!-- TITLE -->
    <div class="resultsTitle">{{ translation.results }}</div>

    <!-- RESULTS LIST -->
    <div class="resultsList">
      <div
        v-for="result in allResults"
        :key="result.id"
        class="resultCard"
        :class="{ gold: result.place === 1, silver: result.place === 2, bronze: result.place === 3 }"
      >
        <div class="resultPlace">
          <span v-if="result.place === 1">🥇</span>
          <span v-else-if="result.place === 2">🥈</span>
          <span v-else-if="result.place === 3">🥉</span>
          <span v-else class="placeNum">{{ result.place }}</span>
        </div>
        <div class="resultInfo">
          <div class="resultUserName">{{ result.resultsOfTheGame.userName }}</div>
          <div class="resultStats">
            <span>⭐ {{ result.resultsOfTheGame.errorNumber }} pts</span>
            <span>⏱ {{ result.resultsOfTheGame.secondsToTime }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- RATING / EMAIL POPUP -->
    <div v-if="showEmailBox" class="over">
      <!-- STEP 1: Stars + Comment -->
      <div class="popCard" v-if="!afterStars">
        <div class="popTitle">{{ translation.howWasIt }}</div>
        <star-rating
          :starSize="starSize"
          v-model="rating"
          :show-rating="false"
          class="starRow"
        ></star-rating>
        <textarea
          name="review"
          rows="3"
          v-model="comment"
          :placeholder="leaveMessage"
          class="popTextarea"
        ></textarea>
        <div class="popActions">
          <div class="popBtnSecondary" @click="afterStars = true">{{ translation.noThanks }}</div>
          <div class="popBtnPrimary" @click="sendComment">{{ translation.send }}</div>
        </div>
      </div>

      <!-- STEP 2: Email + Actions -->
      <div class="popCard" v-if="afterStars">
        <div class="popTitle" style="font-size: 15px; font-weight: 600; opacity: 0.9">{{ translation.leaveEmail }}</div>
        <div class="emailRow">
          <input
            type="email"
            v-model="email"
            placeholder="כתובת מייל"
            class="popEmail"
          />
          <div class="emailSendBtn" @click="sendEmail">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-arrow-left-circle-fill" viewBox="0 0 16 16">
              <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
            </svg>
          </div>
        </div>

        <div class="actionRow">
          <div class="actionItem" @click="showEmailBox = false">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-trophy-fill" viewBox="0 0 16 16">
              <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935z"/>
            </svg>
            <div>{{ translation.backToResults }}</div>
          </div>
          <div class="actionItem" @click="goToHomePage">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-house-fill" viewBox="0 0 16 16">
              <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"/>
              <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"/>
            </svg>
            <div>{{ translation.backToHomePage }}</div>
          </div>
          <div class="actionItem" @click="openWhatsapp">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
            </svg>
            <div>{{ translation.share }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import StarRating from "vue-star-rating";

/* eslint-disable */
export default {
  components: { StarRating },
  data() {
    return {
      leaveMessage: "Laissez-nous quelques mots",
      afterStars: false,
      comment: "",
      starSize: Number(40),
      rating: 5,
      translation: {
        results: "Résultats",
        errors: "Erreurs",
        gameTime: "Temps de jeu",
        totalTime: "Temps total",
        leaveEmail: "Si tu as apprécié le jeu, tu peux nous laisser ton email, on te tiendra au courant chaque fois qu'un nouveau parcours ouvrira !",
        backToHomePage: "Page d'accueil",
        backToResults: "Retour aux résultats",
        howWasIt: "Comment c'était ?",
        noThanks: "Passer",
        send: "Envoyer",
        share: "Partager",
      },
      showEmailBox: true,
      email: "",
      message: "Je viens de terminer un super jeu de piste ! Tu peux y jouer ici : https://eifoany.web.app/" + localStorage.getItem("navigationName"),
    };
  },
  mounted() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () { history.go(1); };
    this.$store.dispatch("getResults", localStorage.getItem("navigationName"));
    this.translate(this.$store.getters.lang);
  },
  computed: {
    lang() { return this.translate(this.$store.getters.lang); },
    gameParameters() { return this.$store.getters.gameParameters; },
    allResults() { return this.$store.getters.results; },
    user() { return this.$store.getters.user; },
  },
  methods: {
    sendComment() {
      this.afterStars = true;
      var comment = {
        navigationName: localStorage.getItem("navigationName"),
        rating: this.rating,
        comment: this.comment,
        time: new Date().toString(),
        user: localStorage.getItem("myNameOuchui"),
      };
      this.$store.dispatch("sendComment", comment);
    },
    translate(lang) {
      switch (lang) {
        case "ar":
          this.leaveMessage = "اتركوا لنا بضع كلمات";
          this.translation = {
            results: "النتائج",
            leaveEmail: "إذا استمتعت باللعبة، اترك لنا بريدك الإلكتروني وسنخطرك عند فتح مسارات جديدة!",
            backToHomePage: "الصفحة الرئيسية",
            backToResults: "العودة إلى النتائج",
            howWasIt: "كيف كانت التجربة؟",
            noThanks: "تخطي",
            send: "إرسال",
            share: "مشاركة",
          };
          break;
        case "he":
          this.leaveMessage = "השאירו לנו כמה מילים";
          this.translation = {
            results: "תוצאות",
            leaveEmail: "אם נהנתם, תשאירו לנו את כתובת המייל שלכם ונודיע לכם כאשר ייפתחו מסלולים חדשים.",
            backToHomePage: "דף הבית",
            backToResults: "לתוצאות",
            howWasIt: "איך היה לכם?",
            noThanks: "לא תודה",
            send: "שלח",
            share: "שתפו",
          };
          break;
        case "en":
          this.leaveMessage = "Leave us a few words";
          this.translation = {
            results: "Results",
            leaveEmail: "If you enjoyed it, leave us your email and we'll let you know when new routes open!",
            backToHomePage: "Home page",
            backToResults: "Back to results",
            howWasIt: "How was it?",
            noThanks: "Skip",
            send: "Send",
            share: "Share",
          };
          break;
        case "de":
          this.leaveMessage = "Hinterlassen Sie uns ein paar Worte";
          this.translation = {
            results: "Ergebnisse",
            leaveEmail: "Wenn es Ihnen gefallen hat, hinterlassen Sie uns Ihre E-Mail und wir informieren Sie, wenn neue Routen öffnen!",
            backToHomePage: "Startseite",
            backToResults: "Zurück zu den Ergebnissen",
            howWasIt: "Wie war es?",
            noThanks: "Überspringen",
            send: "Senden",
            share: "Teilen",
          };
          break;
        default:
          // fr — already set as default in data()
          break;
      }
    },
    openWhatsapp() {
      window.open(`whatsapp://send?text=` + this.message);
    },
    goToHomePage() {
      this.$router.push("/" + localStorage.getItem("navigationName"));
      localStorage.clear();
    },
    sendEmail() {
      this.$store.dispatch("sendEmail", {
        navigationName: this.gameParameters.navigationName,
        email: this.email,
      });
      this.email = "";
    },
  },
};
</script>

<style scoped>
/* ===== FULL SCREEN BACKGROUND ===== */
.resultsScreen {
  position: fixed;
  top: 0; left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  max-width: 590px;
  height: 100vh;
  z-index: 100;
  background: linear-gradient(160deg, #0d1b4b 0%, #1a3a8f 45%, #6b21a8 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding: 70px 16px 32px;
}

/* ===== DECORATIVE DOTS ===== */
.confetti-dot {
  position: fixed;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255,255,255,0.12);
  pointer-events: none;
}
.confetti-dot:nth-child(odd) { background: rgba(245,158,11,0.15); }
.confetti-dot:nth-child(1)  { top: 8%;  left: 12%; width: 10px; height: 10px; }
.confetti-dot:nth-child(2)  { top: 15%; left: 80%; width: 8px; height: 8px; }
.confetti-dot:nth-child(3)  { top: 30%; left: 5%;  }
.confetti-dot:nth-child(4)  { top: 45%; left: 90%; width: 12px; height: 12px; }
.confetti-dot:nth-child(5)  { top: 60%; left: 20%; }
.confetti-dot:nth-child(6)  { top: 70%; left: 75%; width: 9px; height: 9px; }
.confetti-dot:nth-child(7)  { top: 85%; left: 40%; }
.confetti-dot:nth-child(8)  { top: 5%;  left: 55%; width: 7px; height: 7px; }
.confetti-dot:nth-child(9)  { top: 20%; left: 35%; width: 5px; height: 5px; }
.confetti-dot:nth-child(10) { top: 50%; left: 60%; }
.confetti-dot:nth-child(11) { top: 75%; left: 8%;  width: 8px; height: 8px; }
.confetti-dot:nth-child(12) { top: 90%; left: 85%; width: 6px; height: 6px; }
.confetti-dot:nth-child(13) { top: 35%; left: 50%; }
.confetti-dot:nth-child(14) { top: 55%; left: 30%; width: 10px; height: 10px; }
.confetti-dot:nth-child(15) { top: 65%; left: 95%; }
.confetti-dot:nth-child(16) { top: 92%; left: 15%; width: 7px; height: 7px; }

/* ===== HOME BUTTON ===== */
.homeBtn {
  position: fixed;
  top: 72px;
  left: 16px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  backdrop-filter: blur(8px);
  z-index: 10;
  transition: background 0.15s;
}
.homeBtn:active { background: rgba(255,255,255,0.25); }

/* ===== TITLE ===== */
.resultsTitle {
  font-family: VarelaRound, system-ui, sans-serif;
  font-size: 32px;
  font-weight: 900;
  color: white;
  text-align: center;
  margin-bottom: 24px;
  letter-spacing: 1px;
  text-shadow: 0 2px 12px rgba(0,0,0,0.3);
}

/* ===== RESULTS LIST ===== */
.resultsList {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ===== RESULT CARD ===== */
.resultCard {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 18px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 18px;
  backdrop-filter: blur(10px);
  color: white;
  animation: cardSlideIn 0.4s ease-out both;
}

.resultCard.gold   { border-color: rgba(255,215,0,0.5); background: rgba(255,215,0,0.1); }
.resultCard.silver { border-color: rgba(192,192,192,0.4); background: rgba(192,192,192,0.07); }
.resultCard.bronze { border-color: rgba(205,127,50,0.4); background: rgba(205,127,50,0.07); }

@keyframes cardSlideIn {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}

.resultPlace {
  font-size: 36px;
  min-width: 44px;
  text-align: center;
  line-height: 1;
}

.placeNum {
  font-size: 22px;
  font-weight: 800;
  color: rgba(255,255,255,0.6);
}

.resultInfo {
  flex: 1;
  text-align: right;
  direction: rtl;
}

.resultUserName {
  font-size: 20px;
  font-weight: 800;
  font-family: VarelaRound, system-ui, sans-serif;
}

.resultStats {
  display: flex;
  gap: 14px;
  font-size: 14px;
  opacity: 0.8;
  margin-top: 4px;
  flex-direction: row-reverse;
}

/* ===== OVERLAY ===== */
.over {
  position: fixed;
  top: 0; left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  max-width: 590px;
  height: 100vh;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(4px);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ===== POPUP CARD ===== */
.popCard {
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 24px;
  backdrop-filter: blur(16px);
  padding: 28px 24px;
  width: 88%;
  max-width: 340px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.popTitle {
  font-family: VarelaRound, system-ui, sans-serif;
  font-size: 22px;
  font-weight: 800;
  text-align: center;
}

.starRow {
  justify-content: center;
}

.popTextarea {
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.3);
  background: rgba(255,255,255,0.1);
  color: white;
  font-size: 14px;
  padding: 10px;
  resize: none;
  font-family: VarelaRound, system-ui, sans-serif;
}
.popTextarea::placeholder { color: rgba(255,255,255,0.5); }

.popActions {
  display: flex;
  gap: 12px;
  width: 100%;
}

.popBtnPrimary {
  flex: 1;
  background: white;
  color: #1a3a8f;
  font-weight: 800;
  font-size: 15px;
  border-radius: 50px;
  padding: 12px 0;
  text-align: center;
  cursor: pointer;
  transition: transform 0.1s;
}
.popBtnPrimary:active { transform: scale(0.97); }

.popBtnSecondary {
  flex: 1;
  background: rgba(255,255,255,0.1);
  color: white;
  font-weight: 600;
  font-size: 15px;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 50px;
  padding: 12px 0;
  text-align: center;
  cursor: pointer;
}

/* ===== EMAIL ROW ===== */
.emailRow {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.popEmail {
  flex: 1;
  height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.3);
  background: rgba(255,255,255,0.12);
  color: white;
  font-size: 14px;
  padding: 0 12px;
  text-align: center;
}
.popEmail::placeholder { color: rgba(255,255,255,0.5); }

.emailSendBtn {
  color: white;
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.1s;
}
.emailSendBtn:active { opacity: 1; }

/* ===== ACTION ROW (trophy / home / whatsapp) ===== */
.actionRow {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 4px;
}

.actionItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  opacity: 0.9;
  transition: opacity 0.15s;
}
.actionItem:active { opacity: 1; }

@font-face {
  font-family: VarelaRound;
  src: url(../../static/fonts/VarelaRound-Regular.ttf);
}
</style>
